/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMediaImageDataResponse } from '../../models/get-media-image-data-response';

export interface AdminServiceGetMediaImageData$Params {
  mediaId: string;
}

export function adminServiceGetMediaImageData(http: HttpClient, rootUrl: string, params: AdminServiceGetMediaImageData$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMediaImageDataResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceGetMediaImageData.PATH, 'get');
  if (params) {
    rb.path('mediaId', params.mediaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMediaImageDataResponse>;
    })
  );
}

adminServiceGetMediaImageData.PATH = '/api/v3/gateway/admin/media/{mediaId}/image/raw';
